module.exports = __webpack_public_path__ + "static/media/151.24d70ef1.jpg";